export const SURVEYS_HISTORY_INITIAL_SORT = {
  column: 'dateSent',
  asc: false,
  sortKey: '-sent_at',
};
